import React, { useEffect } from 'react';
import { Switch } from '@headlessui/react';
import Utilities from '@util/Utilities';
import _uniqueId from 'lodash/uniqueId';

type Props = {
	isRequired?: boolean,
	form?: any,
	name: string,
	label?: string,
	isLarge?: boolean,
	onChange?: (value: boolean) => any,
	disabled?: boolean
}

const FormSwitch: React.FunctionComponent<Props> = (
	{
		isRequired,
		form,
		name,
		label,
		isLarge = false,
		onChange,
		disabled = false,
	},
) => {

	useEffect(() => {
		form.register(name, { required: isRequired });
	}, [form.register, isRequired]);


	const isChecked = form.watch(name) || false;

	const uniqueId = _uniqueId('input-');

	return <Switch id={uniqueId}
								 checked={isChecked}
								 onChange={(value: boolean) => {
									 form.setValue(name, value);
									 if (!!onChange) onChange(value);
								 }}
								 disabled={disabled}
								 className={Utilities.classNames(
									 isChecked ? 'bg-blue-600' : 'bg-slate-200',
									 !isLarge && 'flex w-8 h-[18px] flex-none cursor-pointer rounded-full p-px ring-1 ring-inset ring-slate-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
									 isLarge && 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
								 )}
	>
		<span className="sr-only">{label}</span>
		<span
			aria-hidden="true"
			className={Utilities.classNames(
				isChecked && !isLarge ? 'translate-x-3.5' : 'translate-x-0',
				isChecked && isLarge ? 'translate-x-5' : 'translate-x-0',
				!isLarge && 'h-4 w-4 transform rounded-full bg-white shadow-sm ring-1 ring-slate-900/5 transition duration-200 ease-in-out',
				isLarge && 'inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
			)}
		/>
	</Switch>;
};

export default FormSwitch;